import React from 'react';

export default function LoadingLoader() {
  return (
    <div className="loading">
      <div className="icon" />
    </div>
  );
}
